<form [formGroup]="form" class="phone-form">
    <div class="phone-row">
        <mat-form-field class="fixed">
            <mat-label>Cód. país</mat-label>
            <input matInput formControlName="countryCode" disabled/>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Área</mat-label>
            <input matInput formControlName="areaCode" #areaInput />
        </mat-form-field>

        <mat-form-field class="fixed">
            <mat-label></mat-label>
            <input matInput formControlName="fixed" disabled />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Número</mat-label>
            <input matInput formControlName="number" />
        </mat-form-field>
    </div>

    <div class="mail-row">
        <mat-form-field>
            <mat-label>Mail</mat-label>
            <input matInput formControlName="mail" />
            <mat-error *ngIf="form.controls.mail.hasError('required')">
                El mail es obligatorio
            </mat-error>
            <mat-error *ngIf="form.controls.mail.hasError('email')">
                El mail ingresado no es válido
            </mat-error>
        </mat-form-field>
    </div>

    <div class="actions">
        <button mat-button (click)="cancel()">Cancelar</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Guardar</button>
    </div>
</form>
